<template>
    <vs-popup id="wage-per-hour-popup" class="wage-per-hour-popup" :title="popupTitle" :active.sync="wagePerHourPopup.isOpen">
        <div class="font-bold color-black mt-3 mb-2 header-row" v-if="wagePerHourPopup && wagePerHourPopup.item_info">
            <p>
                Period payment: {{ getDuration(wagePerHourPopup.item_info.start_date, wagePerHourPopup.item_info.end_date) }}
                <span v-if="getDuration(wagePerHourPopup.item_info.start_date, wagePerHourPopup.item_info.end_date) > 1">Days</span>
                <span v-else>Day</span>
            </p>
            <p class="text-center text-xl ml-4">{{changeFormat(wagePerHourPopup.item_info.start_date)}} to {{changeFormat(wagePerHourPopup.item_info.end_date)}}</p>
            <p class="text-right"></p>
        </div>

        <div class="create-table-overflow mt-6" v-if="salaryList && salaryList.length">
            <div class="h-full overflow-auto">
                <vs-table class="create-table" :data="salaryList">
                    <template slot="thead">
                        <vs-th class="w-1/5 text-center center-title">Date</vs-th>
                        <vs-th class="w-1/5 text-center center-title">Wage Per Hour</vs-th>
                        <vs-th class="w-1/5 text-center center-title">Hour(s)</vs-th>
                        <vs-th class="w-1/5 text-center center-title">Total</vs-th>
                    </template>
                    <template slot-scope="{data}">
                        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                            <vs-td class="font-bold color-black text-center border-left-custom border-top-custom">{{ changeFormat(tr.date) }}</vs-td>
                            <vs-td class="font-bold color-black text-center border-left-custom border-top-custom">${{ tr.salary ? formatPrice(tr.salary.total_salary / (tr.work_hours || 1)) : 0 }}</vs-td>
                            <vs-td class="font-bold color-black text-center border-left-custom border-top-custom">{{ tr.work_hours }}</vs-td>
                            <vs-td class="font-bold color-black text-center border-left-custom border-top-custom">${{ tr.salary ? formatPrice(tr.salary.total_salary) : 0 }}</vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
            </div>
        </div>
    </vs-popup>
</template>

<script>
import moment from "moment";
import { changeFormatHelper } from '../../helper/datetimeHelper';

export default {
    name: "wage-per-hour-popup",
    props: {
        wagePerHourPopup: {
            type: Object
        }
    },
    data() {
        return {
            
        }
    },
    computed: {
        salaryList() {
            return this.$store.getters["goPos/salaryDetail"];
        },
        popupTitle() {
            if(this.wagePerHourPopup && this.wagePerHourPopup.item_info && this.wagePerHourPopup.item_info.employee) {
                return `Wage Per Hour List Of ${this.wagePerHourPopup.item_info.employee.name}`;
            }
            return "Wage Per Hour List Of No Staff";
        }
    },
    watch: {
        wagePerHourPopup: {
            immediate: true,
            deep: true,
            handler() {
                if(this.wagePerHourPopup.isOpen) {
                    document.body.classList.add('overflow-hidden');
                } else {
                    document.body.classList.remove('overflow-hidden');
                }
            }
        }
    },
    methods: {
        getDuration(start_date, end_date) {
            return moment(end_date).diff(moment(start_date), 'days') + 1;
        },
        changeFormat(date) {
            if(date) {
                return changeFormatHelper(date);
            } else {
                return 'N/A';
            }
        },
        formatPrice(value) {
            if(value) {
                // return +(value + "e+2") + "e-2";
                return Math.round(value * 100) / 100;
            }
            return 0;
        }
    }
}
</script>